import { NotificationSettingsEffects } from "./notification-settings/notification-settings.effects";
import { NotificationEffects } from "./notification/notification.effects";



export const coreEffectsAtBootstrap = [NotificationEffects, NotificationSettingsEffects];
